export default __webpack_public_path__ + "static/media/arrow_right.fa9f2215.svg";